<div id="stripe-promo-code">
  @if (!subscription.promoCode) {
    <div class="d-flex align-v-center align-h-space-between">
      <mat-form-field class="no-error w-100" [class.mat-form-field-invalid]="!!errorMessage">
        <mat-label>
          Coupon code
          <i class="icon-info ml-5" matTooltip="Coupon code discounts are applied after system discounts based upon the number of Tanks"></i>
        </mat-label>
        <input #promocodeInput matInput placeholder="Add Coupon Code" [disabled]="isLoading">
      </mat-form-field>
      <div class="ml-10 mt-20 align-h-center">
        <button class="btn link"
                [disabled]="isLoading || !promocodeInput.value"
                [class.c-primary]="!isLoading && promocodeInput.value"
                (click)="apply(promocodeInput.value)">
          <i class="icon mr-10 icon-check ic-primary" [class.ic-text]="isLoading || !promocodeInput.value"></i>
          Apply
        </button>

        @if (isLoading) {
          <app-preloader class="ml-5" [type]="preloaderTypes.ICON"></app-preloader>
        }
      </div>
    </div>
  }

  @if (subscription.promoCode) {
    <app-promo-code [subscription]="subscription" (removed)="remove()"></app-promo-code>
  }
</div>


